import { MutationTree } from 'vuex';
import { IDeleteDirectoryState } from '@/content-library/directories/delete/store/delete-directory.types';
import { EDeleteDirectoryMutation } from '@/content-library/directories/delete/store/delete-directory.constants';

export const mutations: MutationTree<IDeleteDirectoryState> = {
  [EDeleteDirectoryMutation.SetDeleted](state: IDeleteDirectoryState, deleted: boolean) {
    state.deleted = deleted;
  },
  [EDeleteDirectoryMutation.SetDeleting](state: IDeleteDirectoryState, deleting: boolean) {
    state.deleting = deleting;
  },
  [EDeleteDirectoryMutation.SetState](
    state: IDeleteDirectoryState,
    newState: IDeleteDirectoryState
  ) {
    state.deleted = newState.deleted;
    state.deleting = newState.deleting;
  },
};
